import React from 'react';
import { AddButton } from '../../internal-components/form-builder/FormBuilderFieldForm';
import { AddCircleOutline as AddCircleIcon } from '@material-ui/icons';
import Animation from '../Animation';
import Divider from '@material-ui/core/Divider';
import FieldsQueryBuilderEngine from '../conditions-query-builder/engine/FieldsQueryBuilderEngine';
import FlagIcon from '@material-ui/icons/FlagOutlined';
import useTranslations from '../../hooks/useTranslations';
import styled from 'styled-components/macro';

const TitleBar = styled.div`
  margin-bottom: 1rem;
`;

const DividerWithExtraMargin = styled(Divider)`
  margin-bottom: 1rem !important;
`;

const FormBuilderFlagRulesView = props => {
  const t = useTranslations();
  return (
    <div>
      <TitleBar>
        <FlagIcon /> {t('conditional.logic.flag_when')}
      </TitleBar>
      <Animation
        type="collapse"
        in={props.query && props.query.length}
        mountOnEnter
        unmountOnExit
      >
        <DividerWithExtraMargin />
        <FieldsQueryBuilderEngine
          query={props.query}
          form={props.form}
          useStaticFieldId={props.fieldId}
          update={props.onQueryUpdated}
          variant="form-builder"
        />
      </Animation>
      <Animation type="collapse" in={!props.query || !props.query.length}>
        <Divider />
        <AddButton
          data-testid={`formbuilder-flagging-add-condition`}
          color="primary"
          onClick={props.onCreateRule}
          startIcon={<AddCircleIcon />}
        >
          Add a condition
        </AddButton>
        <Divider />
      </Animation>
    </div>
  );
};

export default FormBuilderFlagRulesView;
